module.exports = __webpack_public_path__ + "media/images/front/toplogo_sp-b298c56516fc599da3d66b4f16fac784.png";